<template>
	<!-- 基本信息 -->
	<div class="Minister-top information">
		<div class="Minister-top-top Ministerbackground">
			<div class="Minister-top-left Minister-top-color">店铺和类目</div>
		</div>
		<div class="information_content">
			<div class="information_input" style="margin-bottom:20px;">
				<div class="information_Title">
					<span class="tips">*</span>
					店铺
				</div>
				<div class="input_el input_span">
					<div class="newipt" style="display: flex;">
						<el-select v-model="formData.sellerId" class="width67 " placeholder="请选择"
							:disabled="onlineEdit || system < 5 || isChakan" @change="handleSelectChange">
							<el-option v-for="item in dianpuList" :key="item.sellerId" :label="item.shopName"
								:value="item.sellerId"></el-option>
						</el-select>
					</div>
				</div>
			</div>
			<div class="information_input" style="margin-bottom:20px;">
				<div class="information_Title">
					<span class="tips">*</span>
					平台分类
				</div>
				<div class="input_el input_span">
					<div class="newipt">
						<el-input class="width67" v-model="allLeimuName" maxlength="20" disabled
							@blur="blurLeimu()"></el-input>
						<el-button style="margin-left: 10px" type="primary" @click="selectLeimu"
							v-if="!onlineEdit && !isChakan" :disabled="system < 5 || isChakan">选择类目</el-button>
					</div>
				</div>
			</div>
			<div class="information_input" style="margin-bottom:20px;">
				<div class="information_Title">
					<span class="tips">*</span>
					父SKU
				</div>
				<div class="input_el input_span">
					<div class="newipt">
						<el-input class="width67" v-model="formData.sku" @input="inputSkuchange"
							:disabled="addStatus == 'edit' || system < 5 || isEditLeimu || isChakan"></el-input>
						<el-button style="margin-left: 10px" type="primary" @click="createSku"
							v-if="addStatus != 'edit' && !isEditLeimu && !isChakan"
							:disabled="system < 5">生成编号</el-button>
					</div>
				</div>
			</div>
			<div class="information_input" style="margin-bottom:20px;">
				<div class="information_Title">
					<span class="tips">*</span>
					标题
				</div>
				<div class="input_el input_span">
					<div class="newipt">
						<el-input type="text" class="width85" v-model="formData.name" maxlength="500" show-word-limit
							:disabled="system < 5 || isChakan" @input="inputNamechange">
						</el-input>
						<el-tooltip placement="right-start" effect="light" :open-delay="300"
							v-if="system == 5 && !isChakan">
							<template slot="content">
								首字母大写
							</template>
							<el-button style="background: rgb(245,245,245);color: #b7b4b4" type="primary"
								@click="capitalizeFirstLetter">A
								a</el-button>
						</el-tooltip>
					</div>
					<!-- <div style="margin-top: 5px">
						使用英语，推荐格式: 品牌 + 商品名称+ 型号（如适用）+ 款式（如适用）+ 主要属性+ 包装数量（如适用）+ 尺寸（如适用），将名称长度限制在50至75个字符内可以优化搜索引擎查询结果
					</div> -->
				</div>
			</div>
			<div class="information_input" style="margin-bottom:20px;">
				<div class="information_Title">
					<span class="tips">*</span>
					描述
				</div>
				<div class="input_el input_span">
					<div class="newipt">
						<quill-editor v-model="formData.shortDescription" :options="editorOption"
							:disabled="system < 5 || isChakan"></quill-editor>
					</div>
				</div>
			</div>
			<div class="information_input" style="margin-bottom:20px;">
				<div class="information_Title">
					产品属性
				</div>
				<div class="mL-20 shuxing_box">
					<div class="item_shuxing">
						<div style="width: 100%" class="mL-10">
							<div v-if="topAttributeList && topAttributeList.length > 0">
								<div v-for="(data, index) in topAttributeList"
									:key="data.id ? data.id + '_' + index : index">
									<div style="margin-left: 20%; display: flex; align-items: center;">
										<div v-if="data.isAdd">
											<el-button icon="el-icon-plus" class="shuxing_button"
												@click="addToBianti(data, index)"></el-button>
										</div>
										<div v-if="data.isArray">
											<el-button class="shuxing_buttonArray"
												@click="addArray(data, index)">增加行</el-button>
										</div>
										<div style="width: 80%;">
											<span v-if="data.required === 1" style="color: red;"> * </span>
											<span>{{ data.title }} ({{ data.titleChinese }})</span>
											<el-tooltip v-if="data.descriptionChinese" placement="right-start">
												<div slot="content" class="el_tip_box">{{ data.descriptionChinese }}
												</div>
												<img :src="urlQueImg" class="item_img" alt />
											</el-tooltip>
										</div>
									</div>

									<!-- 判断是否有 children -->
									<div v-if="Array.isArray(data.children) && data.children.length === 0"
										style="margin-left: 20%;">
										<div style="width: 80%; display: flex;">
											<!-- 日期选择 -->
											<el-date-picker v-if="data.oneOfValue === 'date'" v-model="data.value"
												class="shuxing_input" :placeholder="'请选择' + data.titleChinese"
												format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd"></el-date-picker>

											<!-- 普通输入框 -->
											<el-input v-else-if="!data.enumValue && data.type === 'string'"
												:disabled="isChakan || system < 5" class="shuxing_input" autosize
												:placeholder="'请输入' + data.titleChinese" v-model="data.value"
												show-word-limit :type="data.maxLength ? 'textarea' : 'input'"
												:maxlength="data.maxLength"></el-input>

											<!-- 数组输入 -->
											<div v-else-if="!data.enumValue && data.type === 'array'"
												style="width: 100%; display: flex; flex-direction: column;">
												<div v-for="(item, i) in data.value" :key="i"
													style="display: flex; align-items: center; gap: 5px; margin-top: 5px;">
													<el-input class="shuxing_input" style="flex: 1;"
														:disabled="isChakan || system < 5" autosize
														:placeholder="'请输入' + data.titleChinese" v-model="data.value[i]"
														show-word-limit :type="data.maxLength ? 'textarea' : 'input'"
														:maxlength="data.maxLength"></el-input>
													<div v-if="data.isArray && i !== 0">
														<el-button type="error" icon="el-icon-delete"
															@click="deleteArray(data, i)">删除</el-button>
													</div>
												</div>
											</div>

											<!-- 数字输入框 -->
											<el-input
												v-else-if="!data.enumValue && (data.type === 'integer' || data.type === 'number')"
												:disabled="isChakan || system < 5" class="shuxing_input" autosize
												:placeholder="'请输入' + data.titleChinese" v-model="data.value"
												show-word-limit type="number" :max="data.maximum"
												@input="numberInput(data)" :maxlength="data.maxLength"></el-input>

											<!-- 单选下拉 -->
											<el-select
												v-else-if="data.property !== 'marketplace_id' && data.enumValue && data.type === 'string'"
												v-model="data.value" class="shuxing_input" clearable filterable
												:placeholder="'请选择' + data.titleChinese">
												<el-option v-for="(selectItem, i) in data.enumValue"
													:key="i + '_' + selectItem" :label="selectItem"
													:value="selectItem"></el-option>
											</el-select>

											<!-- 多选下拉 -->
											<el-select
												v-else-if="data.property !== 'marketplace_id' && data.enumValue && data.type === 'array'"
												v-model="data.value" class="shuxing_input" clearable multiple filterable
												:placeholder="'请多选择' + data.titleChinese"
												@change="pleaseSelectMore(data, index)">
												<el-option v-for="(selectItem, i) in data.enumValue"
													:key="i + '_' + selectItem" :label="selectItem"
													:value="selectItem"></el-option>
											</el-select>
										</div>
									</div>

									<!-- 渲染 children -->
									<div v-else v-for="(child, childIndex) in data.children"
										:key="child.id ? child.id + '_' + childIndex : childIndex"
										style="margin-left: 20%;">
										<div style="width: 80%; display: flex; margin-top: 5px;">
											<!-- 子属性 日期选择 -->
											<el-date-picker v-if="child.oneOfValue === 'date'" v-model="child.value"
												class="shuxing_input" :placeholder="'请选择' + child.titleChinese"
												format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd"></el-date-picker>

											<!-- 子属性 输入框 -->
											<el-input
												v-else-if="!child.enumValue && (child.type === 'string' || child.type === 'array')"
												:disabled="isChakan || system < 5" class="shuxing_input" autosize
												:placeholder="'请输入' + child.titleChinese" v-model="child.value"
												show-word-limit :type="child.maxLength ? 'textarea' : 'input'"
												:maxlength="child.maxLength"></el-input>

											<!-- 子属性 数字输入框 -->
											<el-input
												v-else-if="!child.enumValue && (child.type === 'integer' || child.type === 'number')"
												:disabled="isChakan || system < 5" class="shuxing_input" autosize
												:placeholder="'请输入' + child.titleChinese" v-model="child.value"
												show-word-limit type="number" :max="child.maximum"
												@input="numberInput(child)" :maxlength="child.maxLength"></el-input>

											<!-- 子属性 下拉选择 -->
											<el-select v-else-if="child.property !== 'marketplace_id'"
												v-model="child.value" class="shuxing_input" clearable filterable
												:placeholder="'请选择' + child.titleChinese">
												<el-option v-for="(selectItem, i) in child.enumValue"
													:key="i + '_' + selectItem" :label="selectItem"
													:value="selectItem"></el-option>
											</el-select>

											<!-- 删除按钮 -->
											<div v-if="childIndex !== 0 && child.isDelete">
												<el-button type="error" icon="el-icon-delete"
													@click="deleteArray(data, childIndex)">删除</el-button>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div v-else>暂无产品属性</div>
						</div>
					</div>
				</div>
			</div>

		</div>
		<el-dialog title="分类选择" :visible.sync="leimuDialog" append-to-body width="1300px" top="10vh">
			<!-- <div style="display: flex;width: 100%">
				<el-input v-model="formData.searchName" placeholder="搜索分类名称" style="margin-right: 20px"
					@change="searchFenlei"></el-input>
				<el-button type="primary" @click="searchFenlei">搜 索</el-button>
				<el-button type="primary" @click="resetFenlei">重 置</el-button>
			</div> -->
			<div v-if="!isSearch"
				style="display: flex;align-items: center;height: 32px;background:rgba(255,244,240,1);font-size: 14px;border: 1px solid indianred;color: indianred;margin-top: 10px;padding-left: 10px">
				<span>当前所选类目是：{{ allLeimuName }}</span>
			</div>
			<div class="search_box" v-if="!isSearch">
				<div class="search_box_item">
					<!-- <el-input v-model="leimuValue1" size="medium" @input="changeLeimu1"></el-input> -->
					<div class="leimu_box">
						<div :class="selectdescId1 == item.id ? 'select_leimu' : ''" class="leimu_item"
							v-for="(item, index) in leimuList1" :key="index" @click="clickLeimu1(item)">
							<div class="leimu_item_desc">{{ item.category }}({{ item.categoryChinese }})</div>
							<i class="el-icon-d-arrow-right item_leimu_you"></i>
						</div>
					</div>
				</div>
				<div class="search_box_item">
					<!-- <el-input v-model="leimuValue2" size="medium" @input="changeLeimu2"></el-input> -->
					<div class="leimu_box">
						<div :class="selectdescId2 == item.id ? 'select_leimu' : ''" class="leimu_item"
							v-for="(item, index) in leimuList2" :key="index" @click="clickLeimu2(item)">
							<div class="leimu_item_desc">{{ item.description }}({{ item.descriptionChinese }})</div>
							<i class="el-icon-d-arrow-right item_leimu_you"></i>
						</div>
					</div>
				</div>
				<div class="search_box_item">
					<!-- <el-input v-model="leimuValue3" size="medium" @input="changeLeimu3"></el-input> -->
					<div class="leimu_box">
						<div :class="selectdescId3 == item.id ? 'select_leimu' : ''" class="leimu_item"
							v-for="(item, index) in leimuList3" :key="index" @click="clickLeimu3(item)">
							<div class="leimu_item_desc">{{ item.productTypeName }}({{ item.productTypeNameChinese }})
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="search_box2" v-if="isSearch">
				<div style="width: 100%">
					<div class="leimu_box2">
						<div :class="selectdescId4 == item.descriptionCategoryId ? 'select_leimu' : ''"
							class="leimu_item" v-for="(item, index) in leimuList4" :key="index"
							@click="clickLeimu4(item)">
							<div class="leimu_item_desc"
								v-html="`${item.fullCategoryNameCn} - ${item.fullCategoryName}`"></div>
						</div>
					</div>
				</div>
			</div>
			<span slot="footer" style="margin-top: 60px">
				<el-button @click="leimuDialog = false">取 消</el-button>
				<el-button type="primary" @click="handleSelectleimu" :disabled="!parentDescriptionCategoryId">选
					择</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
import { ajaxGet, ajaxPost, Baseurl } from "@/api/api/api";
import recuInput from "./recuInput.vue";
import _ from 'lodash';
import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
export default {
	name: 'baseInfoComp',
	components: {
		recuInput,
		quillEditor
	},
	props: {
		score: {
			type: Array,
			default() {
				return [0, 0, 0, 0];
			},
		}
	},
	data() {
		return {
			changeFenleiTime: 0,
			editorOption: {
				placeholder: '请输入...',
			},
			system: 5,
			//在线产品编辑
			onlineEdit: false,
			//是否为查看
			isChakan: false,
			addStatus: 'add',//判断是新增还是编辑
			isEditLeimu: false,//编辑状态修改了类目
			biaotiComplexId4191: '',
			biaotiComplexId13164: '',
			biaotiComplexId11254: '',
			biaotiComplexId21837: '',
			biaotiComplexId21841: '',
			biaotiComplexId21845: '',
			biaotiComplexId4180: '',
			biaotiComplexId9048: '',
			biaotiComplexId8292: '',
			attr9048: undefined,
			attr8292: undefined,
			//角色id
			staffId: '',
			//问号图标的地址
			urlQueImg: require('@/assets/images/wenhao.png'),
			//原始的属性数组
			oldAttributeList: [],
			//上面的属性数组
			topAttributeList: [],
			//变体的属性数组
			bottomAttributeList: [],
			//第三级选中的parentDescriptionCategoryId
			parentDescriptionCategoryId: '',
			typeId: '',
			//是否为点击搜索状态
			isSearch: false,
			//当前所选类目名称
			allLeimuName: '',
			leimuDialog: false,
			//店铺限额数量
			sellCount: 0,
			//已使用
			usage: 0,
			//是否显示店铺限额
			isShowCount: false,
			//店铺List
			dianpuList: [],
			//类目
			leimuList1: [],
			leimuList2: [],
			leimuList3: [],
			leimuList4: [],
			oldleimuList1: [],
			oldleimuList2: [],
			oldleimuList3: [],
			leimuValue1: '',
			leimuValue2: '',
			leimuValue3: '',
			seletObj1: {},
			seletObj2: {},
			seletObj3: {},
			selectdescId1: '',
			selectdescId2: '',
			selectdescId3: '',
			selectdescId4: '',
			swatchVariantAttribute: [],
			branchCompany: [],
			oldTopAttributeList: [],
			//问号图标的地址
			urlQueImg: require('@/assets/images/wenhao.png'),
			formData: {
				//店铺id
				sellerId: '',
				shopId: undefined,
				//parentSku
				sku: '',
				searchName: '',
				//标题
				name: '',
				//产品属性
				productType: '',
				// 品牌
				brand: '',
				countryMark: '',
				typeId: "",
				shortDescription: ''
			},
		}
	},
	created() {
		this.system = JSON.parse(localStorage.getItem('role')).system
		this.staffId = JSON.parse(localStorage.getItem('role')).rid
	},
	methods: {
		pleaseSelectMore(data, index) {
			this.$nextTick(() => {
				this.topAttributeList[index].value = data.value
			})
		},
		getdianpuList(params) {
			ajaxPost(Baseurl + 'roleController/selectNextAndSellerInfoByRid', params).then((res) => {
				var sellerInfos = res.data.data.next
				var newArr = []
				var num = 0
				for (var i = 0; i < sellerInfos.length; i++) {
					var shop = sellerInfos[i].countryMarks
					var sellerId = sellerInfos[i].sellerId
					for (var j = 0; j < shop.length; j++) {
						shop[j].sellerId = sellerId
						newArr[num] = shop[j]
						// newArr[num] = shop[j];
						num++
					}
				}
				this.dianpuList = newArr
			})
		},
		//创建，获取店铺列表
		setDianpuList(arr) {
			this.dianpuList = arr
			this.formData.sellerId = undefined
			this.isShowCount = false
			this.allLeimuName = undefined
			this.formData.sku = undefined
			this.formData.name = undefined
			this.oldAttributeList = []
			this.topAttributeList = []
			this.bottomAttributeList = []
			this.formData.searchName = undefined
			this.formData.shortDescription = undefined
			this.leimuValue1 = undefined
			this.selectdescId1 = undefined
			this.leimuValue2 = undefined
			this.selectdescId2 = undefined
			this.leimuValue3 = undefined
			this.selectdescId3 = undefined
			this.isSearch = false
			this.selectdescId4 = undefined
			this.leimuDialog = false
		},
		formatInputValue(value) {
		},
		//类目id失去焦点,根据类目id自动匹配类目
		blurLeimu(value) {
			// if (value){
			// 	const API = Baseurl + 'ozonCategoryController/ozon/getCategoryByTypeId/' + value
			// 	ajaxGet(API)
			// 			.then((res) => {
			// 				if (res.data.code == 200) {
			// 					if (res.data.data.typeId){
			// 						this.formData.typeId = res.data.data.typeId
			// 						//一共的名称
			// 						this.formData.allTypeName = res.data.data.typeId + '(ID),'+ res.data.data.typeName+ '('+res.data.data.typeNameCn + ')'
			// 					}
			// 				} else {
			// 					this.$message.error(res.data.message)
			// 				}
			// 			})
			// }

		},
		restoreVariants(item) {
			this.topAttributeList.push(item)
		},
		addToBianti(item, index) {
			this.topAttributeList.splice(index, 1)
			//父组件添加变体属性
			this.$emit('addToBianti', item)
		},
		addArray(item) {
			let children = null;
			const matchingAttribute = this.oldTopAttributeList.find(attr => attr.property === item.property);
			if (item.children.length === 0) {
				item.value.push('');
			} else if (matchingAttribute) {
				children = JSON.parse(JSON.stringify(matchingAttribute.childrens));
				children[0].isDelete = true;
				item.children = [...item.children, ...children];
			}
		},
		deleteArray(item, index) {
			if (item.children.length === 0) {
				if (item.value.length <= item.minItems) {
					this.$message.error(`当前属性 ${item.property} (${item.titleChinese}) 最少需要提交 ${item.minItems} 条,暂不可删除!`)
				} else {
					item.value.splice(index, 1);
				}
			} else {
				let deleteIndex = index
				let deleteCount = null;
				this.oldTopAttributeList.forEach((each) => {
					if (item.property == each.property) {
						deleteCount = each
					}
				})
				if (deleteIndex !== -1) {
					item.children.splice(deleteIndex, deleteCount.childrens.length);
				}
			}
		},
		//选择类目 根据parentId 获取下级分类
		selectLeimu() {
			if (this.formData.sellerId != undefined) {
				this.leimuDialog = true
				this.parentDescriptionCategoryId = ''
				this.typeId = ''
				this.getCategoryByParentId(0, 1)
			} else {
				this.$message.error('请先选择店铺后再选择分类!')
			}
		},
		// 选择类目分类
		getleiMuList(list, level) {
			if (level == 2) {
				this.leimuValue2 = ''
				this.selectdescId2 = ''
				this.seletObj2 = {}
				this.leimuList3 = []
				this.oldleimuList3 = []
				this.leimuValue3 = ''
				this.selectdescId3 = ''
				this.seletObj3 = {}
				this.oldleimuList2 = list
				this.leimuList2 = list
				//3级
			} else if (level == 3) {
				this.leimuValue3 = ''
				this.selectdescId3 = ''
				this.seletObj3 = {}
				this.oldleimuList3 = list
				this.leimuList3 = list
			}
		},
		getCategoryByParentId(id, level) {
			const API = Baseurl + 'walmartCategoryController/getCategoryList'
			ajaxGet(API)
				.then((res) => {
					if (res.data.code == 200) {
						this.parentDescriptionCategoryId = ''
						this.typeId = ''
						//一级
						if (level == 1) {
							this.leimuValue1 = ''
							this.selectdescId1 = ''
							this.seletObj1 = {}
							this.leimuList2 = []
							this.oldleimuList2 = []
							this.leimuValue2 = ''
							this.selectdescId2 = ''
							this.seletObj2 = {}
							this.leimuList3 = []
							this.oldleimuList3 = []
							this.leimuValue3 = ''
							this.selectdescId3 = ''
							this.seletObj3 = {}
							this.oldleimuList1 = res.data.data
							this.leimuList1 = res.data.data
						}
					} else {
						this.$message.error(res.data.message)
					}
				})
		},
		clickLeimu1(item) {
			this.selectdescId1 = item.id
			this.parentDescriptionCategoryId = ''
			this.typeId = ''
			this.seletObj1 = item
			this.leimuList2 = []
			this.leimuValue2 = ''
			this.selectdescId2 = ''
			this.seletObj2 = {}
			this.leimuList3 = []
			this.leimuValue3 = ''
			this.selectdescId3 = ''
			this.seletObj3 = {}
			this.getleiMuList(item.productTypeGroupList, 2)
			this.setAllLeimuName(1)
		},
		clickLeimu2(item) {
			this.selectdescId2 = item.id
			this.seletObj2 = item
			this.leimuList3 = []
			this.leimuValue3 = ''
			this.selectdescId3 = ''
			this.seletObj3 = {}
			this.getleiMuList(item.productTypeList, 3)
			this.parentDescriptionCategoryId = ''
			this.typeId = ''
			this.setAllLeimuName(2)
		},
		handleSelectChange(selectedSellerId) {
			const selectedStore = this.dianpuList.find(item => item.sellerId === selectedSellerId);
			if (selectedStore) {
				this.formData.countryMark = selectedStore.countryMark;
				this.$parent.$parent.$refs.bianti.$refs.dingjia.shoujiaCurreny =
					selectedStore.countryMark === 'US' ? 'USD' : selectedStore.countryMark === 'CA' ? 'CAD' : '';
				this.$parent.$parent.$refs.bianti.$refs.dingjia.getHuilv()
			}
		},
		clickLeimu3(item) {
			this.seletObj3 = item
			this.selectdescId3 = item.id
			this.parentDescriptionCategoryId = item.id
			this.formData.categoryId = item.categoryId
			this.formData.typeId = item.id
			this.formData.productType = item.productTypeName
			if (this.addStatus == 'edit') {
				this.isEditLeimu = true
			}
			this.$emit('resetBianti')
			this.setAllLeimuName(3)
		},
		//选中搜索内容
		clickLeimu4(item) {
			this.allLeimuName = item.fullCategoryName + '(' + item.fullCategoryNameCn + ')'
			this.formData.categoryId = item.parentDescriptionCategoryId
			this.leimuDialog = false
			if (this.addStatus == 'edit') {
				this.isEditLeimu = true
			}
			this.$emit('resetBianti')
			this.getAttributeAdd()
		},
		changeLeimu1(val) {
			let leimuList = JSON.parse(JSON.stringify(this.oldleimuList1))
			if (val) {
				this.leimuList1 = leimuList.filter(item => {
					return (item.categoryName.indexOf(val) > -1 || item.categoryNameCn.indexOf(val) > -1)
				})
				this.selectdescId1 = ''
				this.seletObj1 = {}
			} else {
				this.leimuList1 = leimuList
			}
		},
		changeLeimu2(val) {
			let leimuList = JSON.parse(JSON.stringify(this.oldleimuList2))
			if (val) {
				this.leimuList2 = leimuList.filter(item => {
					return (item.categoryName.indexOf(val) > -1 || item.categoryNameCn.indexOf(val) > -1)
				})
				this.selectdescId2 = ''
				this.seletObj2 = {}
			} else {
				this.leimuList2 = leimuList
			}

		},
		changeLeimu3(val) {
			let leimuList = JSON.parse(JSON.stringify(this.oldleimuList3))
			if (val) {
				this.leimuList3 = leimuList.filter(item => {
					return (item.typeName.indexOf(val) > -1 || item.typeNameCn.indexOf(val) > -1)
				})
				this.selectdescId3 = ''
			} else {
				this.leimuList3 = leimuList
			}
		},
		handleChildren(value) {
			let arr = []
			for (let index = 0; index < value.children.length; index++) {
				arr.push([])
				if (value.children[index].children != 0) {
					for (let p = 0; p < value.children[index].children.length; p++) {
						if (value.children[index].children[p].children != 0) {
							arr[index] = value.children[index].children[p].children
						} else {
							arr[index] = value.children[index].children
						}
					}
				}
			}
			let mergedArr = arr.flat();
			return mergedArr
		},
		setInfo(schema) {
			let data = [];
			if (Array.isArray(schema.children)) {
				schema.children.forEach(child => {
					if (child.property === 'Orderable') {
						this.addFlagToChildren(child, 'orderableFlag', 'Orderable');
					} else if (child.property === 'Visible') {
						this.addFlagToChildren(child, 'visibleFlag', 'Visible');
					}
					if (child.children && child.children.length > 0) {
						data = [...data, ...this.setInfo(child)];
					} else {
						if (child.titleChinese != null) {
							let dateIndex = child.titleChinese.indexOf('日期');
							if (dateIndex !== -1) {
								child.oneOfValue = 'date';
							}
						}
						if (child.enumValue != null) {
							child.enumValue = JSON.parse(child.enumValue);
						}
						if (child.oneOf != null) {
							child.oneOf = JSON.parse(child.oneOf);
							child.oneOfValue = child.oneOf[0].format;
						}
					}
				});
			}
			return data;
		},
		addFlagToChildren(node, flagName, flagValue) {
			if (node.children && node.children.length > 0) {
				node.children.forEach(child => {
					child[flagName] = flagValue; // 给每个子节点添加标识符
					this.addFlagToChildren(child, flagName, flagValue);
				});
			} else {
				node[flagName] = flagValue;
			}
		},
		numberInput(items) {
			if (items.maximum != null) {
				if (parseFloat(items.value) > items.maximum) {
					items.value = items.maximum;
				}
			}
		},
		//修改类目名称
		setAllLeimuName(level) {
			if (level == 1) {
				this.allLeimuName = this.seletObj1.category + '(' + this.seletObj1.categoryChinese + ')'
			} else if (level == 2) {
				this.allLeimuName = this.seletObj1.category + '(' + this.seletObj1.categoryChinese + ')' + ' > ' + this.seletObj2.description + '(' + this.seletObj2.descriptionChinese + ')'
			} else if (level == 3) {
				this.allLeimuName = this.seletObj1.category + '(' + this.seletObj1.categoryChinese + ')' + ' > ' + this.seletObj2.description + '(' + this.seletObj2.descriptionChinese + ')' + ' > ' + this.seletObj3.productTypeName + '(' + this.seletObj3.productTypeNameChinese + ')'
			} else {
				this.allLeimuName = ''
			}
		},
		//搜索分类名称
		searchFenlei() {
			if (new Date().getTime() - this.changeFenleiTime < 1000) {
				return;
			}
			this.changeFenleiTime = new Date().getTime()
			this.isSearch = true
			if (!this.formData.searchName) {
				this.clickLeimu4 = []
				return
			}
			const API = Baseurl + 'ozonCategoryController/selectOzonCategoryByName'
			const paramsData = {
				name: this.formData.searchName,
			}
			ajaxPost(API, paramsData)
				.then((res) => {
					const { code, data, message } = res.data
					if (code === 200) {
						this.leimuList4 = data
					} else {
						this.$message.error(message)
					}
				})
				.catch((e) => {
					this.$message.error('查找失败')
				})

		},
		//重置
		resetFenlei() {
			this.isSearch = false
			this.formData.searchName = ''
		},
		setProductIdentifiers(item) {
			this.$parent.$parent.$refs.bianti.setProductIdentifiers(item)
		},
		async getAttributeAdd() {
			this.loading = this.$loading({
				target: this.$refs.dia_box,
				text: '努力加载中...',
				background: 'rgba(218,218,238,0.2)'
			})
			const API = Baseurl + 'walmartProductTypeSpec/getWalmartProductTypeSpecs'
			const paramsData = {
				countryCode: this.formData.countryMark,
				productType: this.formData.productType,
			}
			await ajaxPost(API, paramsData)
				.then(async (res) => {
					const { code, data, message } = res.data
					if (code === 200) {
						this.attr9048 = undefined
						this.attr8292 = undefined
						this.topAttributeList = this.setInfo(data[0].children[1])
						this.topAttributeList = this.handleChildren(data[0].children[1]);
						this.topAttributeList = this.topAttributeList.filter((item) => {
							if (item.property == 'productIdentifiers') {
								this.setProductIdentifiers(item)
							}
							if (item.property == 'brand') {
								this.$set(item, 'value', 'Unbranded');
							}
							if (item.property === 'swatchImages') {
								this.swatchVariantAttribute = item.children.filter((items) => {
									return items.property == 'swatchVariantAttribute'
								})
								return false;
							}
							return item.property !== 'swatchImageUrl' && item.property !== 'productSecondaryImageURL' && item.property !== 'sku' && item.property !== 'productName' && item.property !== 'swatchImages' && item.property !== 'mainImageUrl' && item.property !== 'variantAttributeNames' && item.property !== 'productIdentifiers' && item.property !== 'isPrimaryVariant' && item.property !== 'price' && item.property !== 'shortDescription';
						});
						const enumValueSet = new Set(this.swatchVariantAttribute[0].enumValue);
						this.topAttributeList.forEach(attribute => {
							if (enumValueSet.has(attribute.property)) {
								attribute.isAdd = true;
							}
							if (attribute.enumValue == null && attribute.type == 'array') {
								const childrens = JSON.parse(JSON.stringify(attribute.children));
								this.$set(attribute, 'childrens', childrens);
								this.$set(attribute, 'value', ['']);
								attribute.isArray = true;
							}
							if (attribute.enumValue != null && attribute.type == 'array' && attribute.children == 0 && attribute.property != 'marketplace_id') {
								this.$set(attribute, 'value', []);
							}
							let minArray = [];
							if (attribute.minItems != null) {
								if (!attribute.enumValue) {
									for (let index = 0; index < attribute.minItems; index++) {
										minArray.push('')
									}
									this.$set(attribute, 'value', minArray);
								}
							}
						});
						this.topAttributeList.sort((a, b) => {
							if (a.required === 1 && b.required !== 1) {
								return -1;
							} else if (a.required !== 1 && b.required === 1) {
								return 1;
							} else {
								return 0;
							}
						});
						this.topAttributeList.forEach(attribute => {
							if (enumValueSet.has(attribute.property)) {
								attribute.isAdd = true;
							}
						});
						this.oldTopAttributeList = this.topAttributeList
						this.setBiantiList()
					} else {
						this.$message.error(message)
					}
				})
			this.loading.close()
		},
		//根据商品类型获取属性及属性值   attrList 变体属性  zhuAttributes 主属性
		async getAttributeEdit(attrList, isBian, zhuAttributes, biantizhi) {
			this.loading = this.$loading({
				target: this.$refs.dia_box,
				text: '努力加载中...',
				background: 'rgba(218,218,238,0.2)'
			});
			const API = Baseurl + 'walmartProductTypeSpec/getWalmartProductTypeSpecs';
			const paramsData = {
				countryCode: this.formData.countryMark,
				productType: this.formData.productType,
			};
			try {
				const res = await ajaxPost(API, paramsData);
				const { code, data, message } = res.data;
				if (code !== 200) {
					this.$message.error(message);
					return;
				}
				// 初始化属性
				this.attr9048 = undefined;
				this.attr8292 = undefined;
				let attributes = data[0]?.children[1] || [];
				this.topAttributeList = this.setInfo(attributes);
				this.topAttributeList = JSON.parse(JSON.stringify(this.handleChildren(attributes)));
				this.topAttributeList = this.topAttributeList.filter(item => {
					if (item.property === 'productIdentifiers') this.setProductIdentifiers(item);
					if (item.property === 'swatchImages') {
						this.swatchVariantAttribute = item.children.filter(i => i.property === 'swatchVariantAttribute');
						return false;
					}
					return ![
						'swatchImageUrl', 'productSecondaryImageURL', 'sku', 'productName',
						'swatchImages', 'mainImageUrl', 'variantAttributeNames', 'productIdentifiers',
						'isPrimaryVariant', 'price', 'shortDescription'
					].includes(item.property);
				});
				// 处理 swatch 变体属性
				const enumValueSet = new Set(this.swatchVariantAttribute?.[0]?.enumValue || []);
				this.topAttributeList.forEach(attribute => {
					if (enumValueSet.has(attribute.property)) attribute.isAdd = true;
					if (!attribute.enumValue && attribute.type === 'array') {
						this.$set(attribute, 'value', ['']);
						attribute.isArray = true;
					}
					let minArray = [];
					if (attribute.minItems != null) {
						if (!attribute.enumValue) {
							for (let index = 0; index < attribute.minItems; index++) {
								minArray.push('')
							}
							this.$set(attribute, 'value', minArray);
						}
					}
				});
				// 按 required 排序
				this.topAttributeList.sort((a, b) => (b.required || 0) - (a.required || 0));
				this.oldTopAttributeList = JSON.parse(zhuAttributes.topAttributeList || '[]');
				let mergedObj = {
					...JSON.parse(zhuAttributes.orderableAttributes || '{}'),
					...JSON.parse(zhuAttributes.visibleAttributes || '{}')
				};
				this.topAttributeList.forEach(attribute => {
					let propertyData = mergedObj[attribute.property];
					if (propertyData !== undefined) {
						if (attribute.children.length) {
							attribute.children.forEach(child => {
								let key = child.property;
								if (propertyData[0]?.[key] !== undefined) child.value = propertyData[0][key];
							});
							if (Array.isArray(propertyData) && propertyData.length > 1) {
								let oldAttr = this.oldTopAttributeList.find(attr => attr.property === attribute.property);
								if (oldAttr && Array.isArray(oldAttr.childrens)) {
									propertyData.slice(1).forEach(item => {
										let firstChild = true; // 标记是否是当前 item 的第一个 child
										oldAttr.childrens.forEach(childTemplate => {
											let newChild = { ...childTemplate };
											Object.keys(item).forEach(key => {
												if (newChild.property === key) newChild.value = item[key];
											});
											if (firstChild) {
												newChild.isDelete = true; // 只给第一个 newChild 添加 isDelete
												firstChild = false; // 之后的 child 就不会再加了
											}
											attribute.children.push(newChild);
										});
									});
								}
							} else {
								attribute.children.forEach((child) => {
									if (propertyData.hasOwnProperty(child.property)) {
										child.value = propertyData[child.property];
									}
								});
							}
						} else {
							if (!attribute.enumValue) {
								attribute.value = attribute.type === 'Boolean' ? Boolean(propertyData) : propertyData;
							} else if (attribute.type === 'array') {
								this.$set(attribute, 'value', propertyData);
							} else {
								attribute.value = propertyData;
							}
						}
					}
				});
				// 处理变体数据
				if (this.addStatus === 'add' || isBian === 'wubianti' || this.isEditLeimu) {
					this.topAttributeList = this.oldAttributeList.filter(item => item.isAspect === '0');
					this.bottomAttributeList = this.oldAttributeList.filter(item => item.isAspect === '1');
					this.setBiantiList();
				} else {
					let biantiList = [], zhuShuList = [], arr1 = [];
					let matchedIds = new Set();
					biantizhi.forEach((item, index) => {
						let isPrimaryVariant = JSON.parse(item.variantVisibleAttributes || '{}');
						let variantOrderableAttributes = JSON.parse(item.variantOrderableAttributes || '{}');
						this.$parent.$parent.$refs.bianti.tableList[index].productId = variantOrderableAttributes.productIdentifiers?.productId || '';
						this.$parent.$parent.$refs.bianti.tableList[index].productIdType = variantOrderableAttributes.productIdentifiers?.productIdType || '';
						if (isPrimaryVariant.isPrimaryVariant === 'Yes') {
							this.$parent.$parent.$refs.bianti.selectedVariant = item.name;
						}
						// 用 Set 来避免重复推送
						let tableArr = [];
						let processedAttributes = new Set();
						(item.aspectAttributes || []).forEach(aaItem => {
							if (!processedAttributes.has(aaItem.id)) {
								let matchedAttributes = this.topAttributeList.filter(attr => attr.id === aaItem.id);
								matchedAttributes.forEach(attr => {
									let value = attr.enumValue
										? aaItem.values
										: Array.isArray(aaItem.values) ? [...aaItem.values] : aaItem.values;
									tableArr.push({ value });
									matchedIds.add(attr.id); // 记录已匹配的 ID
								});
								processedAttributes.add(aaItem.id);
							}
						});
						// 将 tableArr 添加到 arr1
						arr1.push(tableArr);
					});
					// 重新分类 topAttributeList
					this.topAttributeList.forEach(item => {
						if (attrList.some(a => a.id === item.id)) {
							biantiList.push(item);
						} else {
							zhuShuList.push(item);
						}
					});
					this.bottomAttributeList = [...biantiList];
					if (this.addStatus === 'add' || isBian === 'wubianti' || this.isEditLeimu) {
						this.setBiantiList();
					} else {
						this.setBiantiList2(arr1);
						this.$nextTick(() => {
							this.topAttributeList = this.topAttributeList.filter(attr => !matchedIds.has(attr.id));
						});
					}
				}
			} catch (error) {
				this.$message.error('请求失败，请重试！');
			} finally {
				this.loading.close();
			}
		},
		handleSelectleimu() {
			this.leimuDialog = false
			this.getAttributeAdd()
		},
		//生成sku编号
		createSku() {
			const paramsData = {
				staffId: this.staffId
			}
			const API = Baseurl + '/commonSettingController/getCommonSettingByStaffId'
			ajaxPost(API, paramsData)
				.then((res) => {
					if (res.data.code === 200) {
						this.formData.sku = res.data.data.sku
						this.$emit('changeSku', this.formData.sku)
					} else {
						this.$message.error(res.data.data)
					}
				})
		},
		inputSkuchange(val) {
			if (val) {
				this.$emit('changeSku', val)
			}
		},
		inputNamechange(val) {
			if (val) {
				this.$emit('changeName', val)
			}
		},

		//首字母大写
		capitalizeFirstLetter() {
			this.formData.name = (this.formData.name.toLowerCase().replace(/\b[a-z]/g, function (match) {
				return match.toUpperCase();
			}))
		},
		//设置变体
		setBiantiList() {
			this.$emit('setBiantiList', this.bottomAttributeList)
		},
		//设置变体
		setBiantiList2(list) {
			this.$emit('setBiantiList2', this.bottomAttributeList, list)
		},
		//在线产品设置变体
		setBiantiList3() {
			this.$emit('setBiantiList3', this.bottomAttributeList)
		},
		//增加下面移除的变体
		addTopAttrList(attrList) {
			this.topAttributeList = this.topAttributeList.concat(attrList)
		}
	}
}
</script>
<style lang="scss" scoped>
@import "../walmart.less";

.shuxing_box {
	min-height: 100px;
	background: rgb(238, 238, 238);
	border-radius: 10px;
	width: 88%;
	float: left;
	padding: 10px 0;
	font-size: 16px;

	.item_shuxing {
		display: flex;
		justify-content: center;
		margin-bottom: 4px;

		.shuxing_label {
			width: 40%;
			text-align: right;
			padding: 3px 10px;

			.shuxing_label_bitian {
				color: red;
				margin-right: 4px;
			}
		}

		.shuxing_input {
			width: 100%;
		}

		.shuxing_select {
			width: 100%;
		}

		.shuxing_button {
			width: 30px;
			height: 30px;
			padding: 0;
			display: flex;
			align-items: center;
			justify-content: center;
			background: rgb(255, 183, 82);
			color: white;
			font-weight: 700;
			font-size: 12px;
			margin-left: 10px;
		}

		.shuxing_buttonArray {
			width: 70px;
			height: 30px;
			padding: 0;
			display: flex;
			align-items: center;
			justify-content: center;
			background: rgb(255, 183, 82);
			color: white;
			font-size: 15px;
			margin-left: 10px;
		}
	}
}

.input_bot_tip {
	display: flex;
	flex-direction: column;
}

.search_box {
	padding: 15px 10px;
	width: calc(100% - 20px);
	background: rgb(238, 238, 238);
	margin-top: 10px;
	display: flex;

	.search_box_item {
		width: 30%;
		margin-right: 20px;

		.leimu_box {
			height: 400px;
			padding: 10px;
			overflow-y: auto;
			background: white;

			.leimu_item {
				display: flex;
				justify-content: space-between;
				align-items: center;
				cursor: pointer;
				padding: 5px 0;
				font-size: 16px;

				.leimu_item_desc {
					width: calc(100% - 20px);
					white-space: nowrap;
					/* 确保文本在一行内显示 */
					overflow: hidden;
					/* 隐藏溢出的内容 */
					text-overflow: ellipsis;
				}

				.item_leimu_you {
					color: rgb(82, 190, 166);
					margin-top: 3px;
				}
			}

			.select_leimu {
				border: 1px solid rgb(82, 190, 166);
				box-sizing: content-box;
			}

			.leimu_item:hover {
				border: 1px solid rgb(82, 190, 166);
				color: rgb(82, 190, 166);
				box-sizing: content-box;
			}
		}
	}

}

.search_box2 {
	padding: 15px 0px 15px 2px;
	width: calc(100%);
	background: rgb(238, 238, 238);
	margin-top: 10px;
}

.leimu_box2 {
	height: 400px;
	padding: 10px;
	overflow-y: auto;
	background: white;
	width: calc(100% - 20px);

	.leimu_item {
		display: flex;
		justify-content: space-between;
		align-items: center;
		cursor: pointer;
		padding: 7px 0;
		font-size: 14px;

		.leimu_item_desc {
			width: calc(100% - 20px);
			white-space: nowrap;
			/* 确保文本在一行内显示 */
			overflow: hidden;
			/* 隐藏溢出的内容 */
			text-overflow: ellipsis;
		}

		.item_leimu_you {
			color: rgb(82, 190, 166);
			margin-top: 3px;
		}
	}

	.select_leimu {
		border: 1px solid rgb(82, 190, 166);
		box-sizing: content-box;
	}

	.leimu_item:hover {
		border: 1px solid rgb(82, 190, 166);
		color: rgb(82, 190, 166);
		box-sizing: content-box;
	}
}

.item_img {
	height: 16px;
	width: 16px;
	margin-left: 5px;
	cursor: pointer
}

.el_tip_box {
	width: 360px;
	font-size: 16px;
	background: rgb(39, 39, 39);
	border-radius: 10px;
	padding: 8px;
	color: whitesmoke;

}
</style>
